import { type FC } from "react";
import DocumentIcon from "../../../components/icons/DocumentIcon";

interface SearchSuggestionListItemProps {
  suggestion: string;
  onClick: (suggestion: string) => void;
}

const SearchSuggestionListItem: FC<SearchSuggestionListItemProps> = ({ suggestion, onClick }) => {
  return (
    <li className="-ml-1.5">
      <button
        type="button"
        tabIndex={-1}
        onClick={() => onClick(suggestion)}
        className="flex gap-x-2 w-full px-1.5 py-0.5 text-lastbot-on-surface cursor-pointer"
        data-testid={`search-suggestion-item`}
      >
        <span className="shrink-0 pt-0.5">
          <DocumentIcon className="size-4 text-lastbot-on-surface-subtle" />
        </span>
        <span className="flex-1 text-left">
          {suggestion}
        </span>
      </button>
    </li>
  );
};

export default SearchSuggestionListItem;
